import { Button, MenuButton } from "@narmi/design_system";
import { useProductListManagerContext } from "../../ProductListManagerContainer";
import { useParams } from "react-router-dom";
import { getCanImport } from "@pages/product_list_manager/utils";
import { AoType, tabTypes } from "@pages/product_list_manager/types";
import ImportModalButton from "../ImportModalButton";
import ImportFromFileModal from "../ImportFromFileModal";
import { useState } from "react";
import jsonFromDocument from "cerulean/src/JsonFromDocument";

const TopBarActions = () => {
  const { type } = useParams();
  const { products, uatProducts, productsForType } = useProductListManagerContext();
  const productList = productsForType(type as AoType);
  const canImport = getCanImport(uatProducts, productList);
  const currentUserIsNarmi = jsonFromDocument("current_user").is_narmi;

  const isTypeParamValid = tabTypes.includes(type as AoType);

  const showActions = !!products.length && isTypeParamValid;
  const [showImportModal, setShowImportModal] = useState(false);
  const [showImportFromFileModal, setShowImportFromFileModal] = useState(false);

  if (!isTypeParamValid) return null;

  if (!showActions) {
    return null;
  }

  return (
    <>
      <MenuButton
        trigger={
          <div className="padding--all--xs">
            <Button label="More" size="xs" startIcon="more-vertical" kind="secondary" />
          </div>
        }
      >
        {canImport && (
          <MenuButton.Item
            label="Import product list"
            onSelect={() => setShowImportModal(true)}
            startIcon="upload"
          />
        )}
        {currentUserIsNarmi && (
          <MenuButton.Item
            label="Import from file"
            onSelect={() => setShowImportFromFileModal(true)}
            startIcon="file-text1"
          />
        )}
        <MenuButton.Item
          label="Download CSV"
          onSelect={() => {
            const link = document.createElement("a");
            link.setAttribute(
              "href",
              "/v1/accountopeningcoreproduct/download/?download_format=csv"
            );
            link.click();
          }}
          startIcon="download"
        />
        <MenuButton.Item
          label="Download XLSX"
          onSelect={() => {
            const link = document.createElement("a");
            link.setAttribute(
              "href",
              "/v1/accountopeningcoreproduct/download/?download_format=xlsx"
            );
            link.click();
          }}
          startIcon="download"
        />
      </MenuButton>
      <ImportModalButton isOpen={showImportModal} onClose={() => setShowImportModal(false)} />
      <ImportFromFileModal
        isOpen={showImportFromFileModal}
        onClose={() => setShowImportFromFileModal(false)}
      />
    </>
  );
};

export default TopBarActions;
